export class GenericPlateUpdateDTO{
    labID!: string;
	plateID!: string;
	puid!: string	
	version!: number;
	processStepName!: string;
	status!: string;
	updateType!: string;
	actionName!: string;
	actionType!: string;
	runtime!: number;
	storagePlate?: boolean;
}